export const stringsKey = "TemplateLibraryViewPage";
export const englishStrings = {
	titleMessage: "CHOOSE YOUR FLOW",
	batchMessageCardHeader: "Configure batch messages",
	batchMessageCardBody:
		"Use a simple 6-step wizard to configure and schedule batch messages to be sent to people affected. Contains the ability to setup reoccurring batch messaging sends. Reach supports sending batch messages via Twilio SMS, Africa’s Talking SMS, Twilio Voice, and Twilio WhatsApp.",
	requestForHelpCardHeader: "Request For Help",
	requestForHelpCardBody:
		"Use Reach’s flexible drag and drop flow builder to create inbound Request for Help journeys. The Request for Help builder supports creating Twilio SMS, Twilio Voice, Twilio WhatsApp, and Telerivet USSD inbound flows. Once created, use Reach to quickly generate and deploy your flow.",
	createButtonText: "Create",
	backButtonText: "Back",
	addButtonText: "Add Template",
	date: "Date",
	countryName: "Country Name",
	countryCode: "Country Code",
	title: "Title",
	batchMessageType: "Batch Message Type",
	action: "Action",
	useTemplateButton: "Use Template",
};
